// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__361Mh","col":"Table_col__6SpZD","fulfillmentStatus":"Table_fulfillmentStatus__1m0rJ","emailCol":"Table_emailCol__dVNHZ"};